import { API } from 'aws-amplify';
import { Resident } from '@/residents/resident.model';

export function useResidents() {
  return {
    fetchResidents,
    deleteResident,
  }
}

function fetchResidents(): Promise<Resident[]> {
  return API.get('API', '/v1/payor/residents', {});
}

function deleteResident(residentId: string) {
  return API.del('API', `/v1/payor/residents/${residentId}`, {});
}
